import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import * as TaskManagementStateController from "../../store/StateControllers/TaskManagement/TaskManagementStateController";
import * as DataModels from "../../store/Models/TaskManagement/TaskManagementDataModel";
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import Layout from "../Layout";
import { ScrollableContent, TopActionButtons, TopActionsAndScrollableContentContainer } from "../core/TopActionsAndScrollableContentContainer";
import { TableColumn, TableRow, ToxnotReactTable } from "../core/ToxnotReactTable";
import './styles.css';
import React, { MouseEvent } from "react";
import { SelectedInventoriesManager } from "../../store/Managers/SelectedInventoriesManager";
import { Link } from "react-router-dom";
import { SlidingDrawer } from "../core/SlidingDrawer";
import { LoadingSpinner, LoadingSpinnerSize } from "../core/LoadingSpinner";
import { TaskProps } from "./TaskManagementMain";
import { getDateIsoString, getLinkedItemLink, stringToTaskStatusEnumMap } from "../../store/StateControllers/TaskManagement/TaskManagementStateController";
import * as Helpers from  "../../store/StateControllers/TaskManagement/Helpers";
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from "../core/ToxnotReactModal";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from "../../store/Models/UserContext";


interface TaskDetailViewProps {
    localStorageFilterKey: string,
    localStorageTaskIdKey: string
}

type DetailProps = TaskProps & TaskDetailViewProps;

class TaskManagementDetailView extends ToxnotSignInRequiredComponent<DetailProps> {
    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }


    private _requestStateToDescriptionMap = [
        this.localizeString("Request Sent"),
        this.localizeString("In Progress"),
        this.localizeString("Response Received"),
        this.localizeString("Response Accepted"),
        this.localizeString("Draft"),
        this.localizeString("Response Partially Accepted"),
        this.localizeString("Revision Request Sent"),
        this.localizeString("Revision In Progress"),
        this.localizeString("Revision Response Received")
    ];

    //
    // Main Components
    //
    public renderConcreteComponent(): JSX.Element | null {

        if (!this.props.tasks) {
            return null;
        }

        const taskId = this.props.openTaskId;
        const assignedBy = taskId !== null ? this.props.teamMembers.find(t => t.userId === this.props.tasks[taskId].assignedByUserId) ?? null : null;
        const assignedByName = assignedBy !== null ? assignedBy.firstName + " " + assignedBy.lastName : "";

        const linkedInventories: DataModels.TaskManagementLinkedItem[] = taskId !== null ? this.props.tasks[taskId].linkedItems.filter(v => v.itemType === DataModels.TaskManagementLinkedItemType.Inventory) : [];
        const linkedSurveys: DataModels.TaskManagementLinkedItem[] = taskId !== null ? this.props.tasks[taskId].linkedItems.filter(v => v.itemType === DataModels.TaskManagementLinkedItemType.Survey) : [];
        const linkedCustomerRequests: DataModels.TaskManagementLinkedItem[] = taskId !== null ? this.props.tasks[taskId].linkedItems.filter(v => v.itemType === DataModels.TaskManagementLinkedItemType.CustomerRequest) : [];
        const linkedDocuments: string[] = taskId !== null ? this.props.tasks[taskId].attachedFileIds : [];

        return (
            <>
                <SlidingDrawer drawerTitle={this.props.openTaskId !== null ? this.props.tasks[this.props.openTaskId].title : ""} openDrawer={this.props.openTaskId !== null} onClose={() => this.props.setTaskManagementState({ openTaskId: null })}>
                    {taskId === null ? null :
                    <div className="grouped-data">
                        <div className="group">
                            <div className="title">{this.localizeString("Edit Task Details")}</div>
                            <div className="content">
                                <div className="form-group">
                                    <label>{this.localizeString("Title")}</label>
                                    <input className="form-control" type="text" value={this.props.tasks[taskId].title} onChange={(e) => this.props.modifyTaskState(taskId, { title: e.target.value }, this.props.tasks[taskId])} />
                                </div>
                                <div className="tn-section-row">
                                    <div className="tn-section-col-5">
                                        <div className="form-group">
                                            <label>{this.localizeString("Assigned To ")}<span className="label-sub-text">{this.localizeString("(" + "Assigned By ") + assignedByName + ")"}</span></label>
                                            {this.renderAssignedToSelect(this.props.tasks[taskId])}
                                        </div>
                                    </div>
                                    <div className="tn-section-col-5 tn-section-col-offset-1">
                                        <div className="form-group">
                                            <label>{this.localizeString("State")}</label>
                                            {this.renderStateSelect(this.props.tasks[taskId])}
                                        </div>
                                    </div>
                                </div>
                                <div className="tn-section-row">
                                    <div className="tn-section-col-5">
                                        <div className="form-group">
                                            <label>{this.localizeString("Due Date")}</label>
                                            {this.renderDateInput(this.props.tasks[taskId])}

                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>{this.localizeString("Description")}</label>
                                    <textarea className="form-control" rows={8} value={this.props.tasks[taskId].description} onChange={(e) => this.props.modifyTaskState(taskId, { description: e.target.value }, this.props.tasks[taskId])} />
                                </div>                                        
                            </div>
                        </div>
                        <div className="group">
                            <div className="title">{this.localizeString("Linked Items")}</div>
                            <div className="content">
                                <div className="form-group">
                                        {linkedSurveys.length <= 0 && linkedCustomerRequests.length <= 0 && <button className="btn btn-default btn-margin-right" role="button" onClick={e => this.linkMaterialsProducts_ButtonClicked(this.props.tasks[taskId])} >{this.localizeString("Link Products/Materials")}</button>}
                                        {linkedInventories.length <= 0 && linkedCustomerRequests.length <= 0 && <button className="btn btn-default btn-margin-right" role="button" onClick={e => this.linkSurvey_click()}>{this.localizeString("Link Survey")}</button>}
                                    <button className="btn btn-default" role="button" onClick={e => document.getElementById("task-hidden-file-picker")?.click()}>{this.localizeString("Attach a File")}</button>
                                    <input type="file" style={{ display: "none" }} id="task-hidden-file-picker" onChange={e => this.onAttachFileButton_Clicked(e, taskId)} />
                                </div>
                                <div className="form-group">
                                
                                    <table className="table tn-table">
                                        <thead>
                                            <tr>
                                                <td>{this.localizeString("Type")}</td>
                                                <td>{this.localizeString("Linked Items")}</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {linkedInventories.length > 0 &&
                                            <tr>
                                            <td>{this.localizeString("Materials/Product")}</td>
                                                <td>
                                                    <table><tbody>
                                                    {
                                                        linkedInventories.map((value, _) =>
                                                            <tr key={value.itemId}>
                                                                <td className="task-linked-items"><a href={getLinkedItemLink(value)}>{this.getLinkedItemFriendlyDescription(value)}</a></td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody></table>
                                                </td>
                                            </tr>}
                                            {linkedSurveys.length > 0 &&
                                            <tr>
                                                <td>{this.localizeString("Surveys")}</td>
                                                <td>
                                                    <table><tbody>
                                                    {
                                                        linkedSurveys.map((value, _) =>
                                                            <tr key={value.itemId}>
                                                                <td className="task-linked-items"><a href={getLinkedItemLink(value)}>{this.getLinkedItemFriendlyDescription(value)}</a></td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody></table>
                                                </td>
                                            </tr>}
                                            {linkedDocuments.length > 0 &&
                                            <tr>
                                                <td>{this.localizeString("Documents")}</td>
                                                <td>
                                                    <table><tbody>
                                                    {
                                                        linkedDocuments.map((value, _) =>
                                                            <tr key={value}>
                                                                <td className="task-linked-items"><a href={"/Api/v2/GeneralFile?fileId="+value}>{this.props.filesTable[value]}</a></td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody></table>
                                                </td>
                                            </tr>}
                                            {linkedCustomerRequests.length > 0 &&
                                            <tr>
                                                <td>{this.localizeString("Customer Requests")}</td>
                                                <td>
                                                    <table><tbody>
                                                    {
                                                        linkedCustomerRequests.map((value, _) =>
                                                            <tr key={value.itemId}>
                                                                <td className="task-linked-items"><a href={getLinkedItemLink(value)}>{this.getLinkedItemFriendlyDescription(value)}</a></td>
                                                            </tr>
                                                        )
                                                    }
                                                    </tbody></table>
                                                </td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>}
                </SlidingDrawer>
                <ToxnotReactModal modalId={"task-data-collection-request-picker"} localizedTitle={this.localizeString("Select a survey to link.")}>
                    <ToxnotReactModalBody> 
                        <table className="table toxnot-table-v2 tn-react-table">
                            <thead>
                                <tr>
                                    <td>{this.localizeString("Name")}</td>
                                    <td>{this.localizeString("From")}</td>
                                    <td>{this.localizeString("Send To")}</td>
                                    <td>{this.localizeString("Survey Type")}</td>
                                    <td>{this.localizeString("Status")}</td>
                                    <td>{this.localizeString("Actions")}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.surveyList.map((value, _) =>
                                        <tr key={value.requestId}>
                                            <td>{value.surveyName}</td>
                                            <td>{value.fromname}</td>
                                            <td>{value.sendToEmail}</td>
                                            <td>{value.surveyType}</td>
                                            <td>{this._requestStateToDescriptionMap[value.state]}</td>
                                            <td> <button className="btn btn-default" onClick={e => this.linkSurveyToTask(e, value.requestId)}>{this.localizeString("Link")}</button></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </ToxnotReactModalBody>
                    <ToxnotReactModalFooter localizer={this.props.appServices} enabledCloseButton={false}>
                        <button type="button" className="btn btn-toxnot-primary" onClick={this.closeLinkSurveyModal_click}>{this.localizeString("Cancel")}</button>
                    </ToxnotReactModalFooter>
                </ToxnotReactModal>
            </>
        );
    }

    private closeDataCollectionRequestPickerModel(e: MouseEvent) {
        e.nativeEvent.stopImmediatePropagation();
        $('#task-data-collection-request-picker').modal('hide');
    }

    private linkSurveyToTask = (e: MouseEvent, surveyId: string) => {
        this.closeDataCollectionRequestPickerModel(e);

        if (this.props.openTaskId != null) {
            this.props.modifyTaskState(this.props.openTaskId, { linkedItems: [{ itemId: surveyId, itemType: DataModels.TaskManagementLinkedItemType.Survey }] }, this.props.tasks[this.props.openTaskId]);
        }
    }


    private linkMaterialsProducts_ButtonClicked = (task: DataModels.Task) => {
        localStorage.setItem(this.props.localStorageTaskIdKey, task.taskId);
        localStorage.setItem(this.props.localStorageFilterKey, JSON.stringify(this.props.taskFilters));
        SelectedInventoriesManager.navigateToSelectInventoriesPage("Select Materials Or Products To Link To Task");

    }

    private getLinkedItemFriendlyDescription(linkedItem: DataModels.TaskManagementLinkedItem) {
        switch (linkedItem.itemType) {
            case DataModels.TaskManagementLinkedItemType.Inventory:
                return this.localizeString("Material/Product: ") + this.props.inventoryIdToInventoryNamesMap[linkedItem.itemId]?.name ?? "";
            case DataModels.TaskManagementLinkedItemType.Survey:
                return this.localizeString("Survey: ") + this.props.surveyList.firstOrDefault(x => x.requestId === linkedItem.itemId)?.surveyName ?? "";
            case DataModels.TaskManagementLinkedItemType.CustomerRequest:
                return "Customer Request";
        }
    }

    private onAttachFileButton_Clicked = async (e: React.ChangeEvent<HTMLInputElement>, taskId: string) => {
        if ((e.target.files === null) || (e.target.files.length === 0)) {
            return;
        }
        const files = e.target.files;

        await this.props.uploadFiles(taskId, files);
        // Clear the file so another import is possible.
    }

    private linkSurvey_click = () => {
        $('#task-data-collection-request-picker').modal('show');
    }

    private closeLinkSurveyModal_click = (e: MouseEvent) => {
        this.closeDataCollectionRequestPickerModel(e);
    }

    //
    //Input Renderers
    //

    private renderAssignedToSelect(data: DataModels.Task): JSX.Element{
        return (
            <select className="form-control" value={data.assignedUserId ?? ""} onChange={(e) => this.props.modifyTaskAssignedToState(data.taskId,e.target.value, data)}>
                {this.props.teamMembers.map((v, i) => {
                    return (
                        <option value={v.userId} key={i}>
                            {Helpers.getAssignedTeamMemberName(v)}
                        </option>
                    );
                })}
            </select>  
        );
    }

    private renderStateSelect(data: DataModels.Task): JSX.Element {
        return (
            <select className="form-control" value={data.status.toString()} data-value={data.status.toString()} onChange={(e) => this.props.modifyTaskState(data.taskId, { status: stringToTaskStatusEnumMap()[e.target.value] }, data)}>
                <option value={DataModels.TaskStatus.New}>{this.localizeString("New")}</option>
                <option value={DataModels.TaskStatus.Active}>{this.localizeString("Active")}</option>
                <option value={DataModels.TaskStatus.Closed}> {this.localizeString("Closed")}</option>
            </select>    
        );
    }

    private renderDateInput(data: DataModels.Task): JSX.Element {
        return (
            <input type="date" className="form-control" value={data.deadlineDate?.substring(0, 10) ?? ""} onChange={(e) => this.props.modifyTaskDueDate(data.taskId, getDateIsoString(e.target.value), data)} />    
        );
    }
}

export default connect(
    (state: ApplicationState, ownProps: TaskDetailViewProps) => ({ ...state.taskManagementState, appServices: state.appServices }),
    TaskManagementStateController.actionCreators
)(withRouter(TaskManagementDetailView) as any);